import { render } from "./DatosBancarios.vue?vue&type=template&id=4527c85c&scoped=true"
import script from "./DatosBancarios.vue?vue&type=script&lang=js"
export * from "./DatosBancarios.vue?vue&type=script&lang=js"

import "./DatosBancarios.vue?vue&type=style&index=0&id=4527c85c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4527c85c"]])

export default __exports__